import React from 'react';
// import Maincntr from './myProfile/Maincntr';
import UserProfile from './UserProfile';

function App() {
  return (<>
    <UserProfile />
    {/* <Maincntr /> */}
   </>
  );
}

export default App;